import pluralize from "pluralize";
import {useState} from "react";

import {Button} from "@/components/button/Button.tsx";
import {AnalyzerCheckCellProps} from "@/pages/analyzer/Analyzer.types.ts";
import {getUncreatedMemberIds} from "@/pages/analyzer/Analyzer.utils.ts";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";
import {CheckSnippetModal} from "@/pages/checks/update/sections/CheckSnippetModal.tsx";
import {hasSnippet} from "@/pages/checks/utils.ts";

export const AnalyzerCheckStatusCell = ({check}: AnalyzerCheckCellProps) => {
  const {creationOutcome, formData} = useAnalyzerContext();
  const [showSnippet, setShowSnippet] = useState(false);
  const createdId = creationOutcome?.createdByProposalId[check.id];
  const uuid = creationOutcome?.uuidByProposalId[check.id];

  if (createdId) {
    if (hasSnippet(check.monitoring_service_type) && uuid && formData) {
      return (
        <>
          <Button variant="linkBlue" size="fitContent" typography="link" onClick={() => setShowSnippet(true)}>
            Get snippet
          </Button>
          <CheckSnippetModal
            show={showSnippet}
            onClose={() => setShowSnippet(false)}
            serviceType={check.monitoring_service_type}
            snippets={formData.snippets}
            uuid={uuid}
          />
        </>
      );
    }
    // a created Group can still take new members; the count tells the user what an update adds
    const newMembers = getUncreatedMemberIds(check, creationOutcome?.createdByProposalId ?? {}).length;
    const suffix = newMembers ? `, ${newMembers} new ${pluralize("member", newMembers)}` : "";
    return <span className="text-success">Created{suffix}</span>;
  }

  const error = creationOutcome?.errorsByProposalId[check.id];
  return error ? (
    <span className="text-danger" title={error}>
      {error}
    </span>
  ) : null;
};
